/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'plane',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M152,176H88c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-32C160,179.582,156.418,176,152,176z
       M144,208H96v-16h48V208
       
      M248,176h-64c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-32C256,179.582,252.418,176,248,176z
       M240,208h-48v-16h48V208
       
      M344,176h-64c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8v-32C352,179.582,348.418,176,344,176z
       M336,208h-48v-16h48V208
       
      M477.656,202.344l-56-56c-1.5-1.5-3.534-2.344-5.656-2.344H300.432L222.784,19.76C221.322,17.421,218.758,16,216,16h-64
			c-4.418,0-8,3.582-8,8v120h-27.528L54.816,43.808C53.36,41.441,50.779,39.999,48,40H8c-4.418,0-8,3.582-8,8v184
			c0.044,39.746,32.254,71.956,72,72h72v152c0,4.418,3.582,8,8,8h64c3.121,0,5.956-1.815,7.264-4.648L294.968,304H408
			c39.746-0.044,71.956-32.254,72-72v-24C480,205.878,479.156,203.844,477.656,202.344z M460.688,208H400v-16h44.688L460.688,208z
			 M160,32h51.56l70.04,112H160V32z M16,56h27.528l54.152,88H16V56z M210.88,448H160V256h139.496L210.88,448z M464,232
			c-0.035,30.913-25.087,55.965-56,56H302.352l16.912-36.648c1.851-4.012,0.1-8.765-3.912-10.616
			C314.301,240.251,313.157,240,312,240H152c-4.418,0-8,3.582-8,8v40H72c-30.913-0.035-55.965-25.087-56-56v-72h396.688l16,16H392
      c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h72V232
      
      ${utils.rect(64, 24, 64, 16)}

      ${utils.rect(96, 56, 32, 16)}

      ${utils.rect(64, 400, 64, 16)}

      ${utils.rect(96, 432, 32, 16)}
      
      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/plane.js